module.exports = __webpack_public_path__ + "img/login_backdrop.8ef6c813.png";